module.exports = __webpack_public_path__ + "img/mid-shadow-investor-card.2eabd9b5.svg";